import React from 'react';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer'; // Polyfills for libraries expecting Node globals in the browser
import './index.css';
import './assets/styles/utilities.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ensure global and Buffer are available in the browser after imports
if (typeof window !== 'undefined') {
  if (!window.global) window.global = window;
  if (!window.Buffer) window.Buffer = Buffer;

  // Prevent mouse wheel from changing values on focused number inputs globally
  // Works across the app without per-component changes
  const onWheel = (e) => {
    try {
      const target = e.target;
      const numberInput = target && (typeof target.closest === 'function'
        ? target.closest('input[type="number"]')
        : (target.tagName === 'INPUT' && target.type === 'number' ? target : null));
      const active = document.activeElement;
      if (numberInput && active === numberInput) {
        // Prevent scroll changing the numeric value
        e.preventDefault();
      }
    } catch (_) {
      // no-op
    }
  };
  // Use passive: false so preventDefault is honored
  window.addEventListener('wheel', onWheel, { passive: false, capture: true });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
